// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"decorationBarStyle_mainContainer__3eMN4","decorationBar":"decorationBarStyle_decorationBar__1ZEuT"};